import { ErrorResponse } from "@apollo/client/link/error";
import { LogGraphQLError } from "error/loggers/graphql-error-logger";
import { LogNetworkError } from "error/loggers/network-error-logger";
import { isAuthRedirectError } from "features/Authentication/authRecovery";

export const GetErrorHandler =
  () =>
  ({ graphQLErrors, networkError }: ErrorResponse) => {
    if (graphQLErrors)
      graphQLErrors.forEach(({ extensions, message, locations, path }) => {
        LogGraphQLError(message, extensions, locations, path);
      });

    if (networkError) {
      if (isAuthRedirectError(networkError)) {
        return;
      }

      LogNetworkError(networkError);
    }
  };
